export const SYSTEM_PAGE_TITLE = 'Obraa | Sistema de gestão de obras';
export const MARKETPLACE_PAGE_TITLE = 'Obraa | Marketplace para venda e locação de imóveis';
